<script>
import _ from 'lodash'
import UiFormFromarchetype from '../../elements/ui-form-fromarchetype.vue'
import { usuarioClientedatosArchetype } from './clientedatosArchetype'

export default {
    name: 'UsuariosClientedatos',
    components: { UiFormFromarchetype },

    props: {
        debug: {
            type: Boolean,
            default: false
        },
        value: {
            type: Object
        },
        source: {
            type: Object
        },
        estados: {
            type: Array,
            required: true
        }
    },

    data: () => {
        return {
            usuarioClientedatosArchetype,
            workingValue: {

            }
        }
    },

    methods: {
        changed() {
            console.log('changed', this.workingValue)
        }
    },

    computed: {
        usuarioClientedatosArchetypeComputed() {
            let resp = []
            _.forEach(this.usuarioClientedatosArchetype, item => {
                if (_.isArray(item) && item[0].key == 'idestado_fk') {
                    item[0].type = 'select';
                    item[0].options = _.clone(this.estados)
                }
                resp.push(item)
            })
            return resp
        }
    },

    watch: {
        workingValue() {
            this.$emit('input', this.workingValue)
        }
    },

    beforeMount() {
        this.workingValue = _.clone(this.value)
    }
}
</script>

<template>
    <div id="UsuariosClientedatos">
        <!-- <b-card class="card-clientedatos" header="Datos de usuario"> -->
            <ui-form-fromarchetype v-model="workingValue"
                :form-archetype="usuarioClientedatosArchetypeComputed" 
                :source="source" 
                @updated="changed" />
                <div class="debug" v-if="debug">
                    <h6>value</h6>
                    <code>
                        <pre>{{ value }}</pre>
                    </code>
                    <h6>workingValue</h6>
                    <code>
                        <pre>{{ workingValue }}</pre>
                    </code>
                    <h6>usuarioClientedatosArchetype</h6>
                    <code>
                        <pre>{{ usuarioClientedatosArchetype }}</pre>
                    </code>
                </div>
        <!-- </b-card> -->
    </div>
</template>